import moment from "moment";
import { REPORT_NAMES } from "../constants";

/**
 * Returns the default date range filter for a report, or null if none applies.
 */
function getDefaultDateRangeFilter(reportName) {
  switch (reportName) {
    case REPORT_NAMES.MEDIA_STATUS_REPORT:
    case REPORT_NAMES.MEDIA_STATUS_REPORT_SALES:
      return {
        from: new Date(moment()),
        id: "dateRange",
        type: "dateRange",
        displayName: `${moment().format("DD/MM/YYYY")} - ${moment()
          .add(7, "days")
          .format("DD/MM/YYYY")}`,
        to: new Date(moment().add(7, "days")),
      };
    case REPORT_NAMES.CAMPAIGN_SCHEDULE_STATUS_REPORT:
      return {
        from: new Date(moment().startOf("day")),
        id: "dateRange",
        type: "dateRange",
        displayName: `${moment().format("DD/MM/YYYY")} - ${moment()
          .add(7, "days")
          .format("DD/MM/YYYY")}`,
        to: new Date(moment().add(7, "days").endOf("day")),
      };
    case REPORT_NAMES.SLATE_DELIVERY_PERFORMANCE_REPORT:
      return {
        // set date range to previous week (Sunday to Saturday)
        from: new Date(moment().startOf("week").subtract(1, "week")),
        id: "dateRange",
        type: "dateRange",
        displayName: `${moment()
          .startOf("week")
          .subtract(1, "week")
          .format("DD/MM/YYYY")} - ${moment()
          .endOf("week")
          .subtract(1, "week")
          .format("DD/MM/YYYY")}`,
        to: new Date(moment().endOf("week").subtract(1, "week")),
      };
    default:
      return null;
  }
}

export default getDefaultDateRangeFilter;
